import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { PricingItemDto } from '../../../shared/modules/pricing-items/dtos/pricing-item.dto';
import { RentalAgreementSearchDto } from '../../rental-agreements';
import { TagListDto } from '../../tags/dtos/tag-list.dto';
import { VehicleSearchDto } from '../../vehicles';
import { VehicleDamageFaultEnum } from '../enums/vehicle-damage-fault.enum';
import { VehicleDamageRecordCategoryEnum } from '../enums/vehicle-damage-record-category.enum';
import { VehicleDamageSeverityEnum } from '../enums/vehicle-damage-severity.enum';
import { VehicleDamageStatusEnum } from '../enums/vehicle-damage-status.enum';
import { VehicleDamageTypeEnum } from '../enums/vehicle-damage-type.enum';

import { VehicleDamageLinksDto } from './vehicle-damage-links.dto';

/**
 * Vehicle damage record DTO
 */
@CaslSubject(AppSubjectEnum.VEHICLE_DAMAGE)
export class VehicleDamageRecordDto extends BaseDto {
	code!: string;
	status!: VehicleDamageStatusEnum;
	notes?: string | null;
	recordCategory!: VehicleDamageRecordCategoryEnum;
	reportedAt!: Date;
	type?: VehicleDamageTypeEnum | null;
	severity?: VehicleDamageSeverityEnum | null;
	fault?: VehicleDamageFaultEnum | null;
	policeReportFiled?: boolean | null;
	policeReportExternalReference?: string | null;
	estimatedCost?: number | null;
	vehicleId?: number | null;
	vehicle?: VehicleSearchDto | null;
	rentalAgreementId?: number | null;
	rentalAgreement?: RentalAgreementSearchDto | null;
	scrapId?: number | null;
	thirdPartyContactId?: number | null;
	thirdPartyInsuranceId?: number | null;
	insuranceClaimId?: number | null;
	pricingItems?: PricingItemDto[] | null;
	tags?: TagListDto[] | null;
	links?: VehicleDamageLinksDto | null;
	files?: FileDto[] | null;
}
